<form class="row" [formGroup]="form">
  @if(isReadOnly){
  <div class="col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="">
        {{ "case.case-informations.assurance-type" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.assuranceType?.label"
      ></app-readonly-input>
    </div>

    <div
      class="mb-3"
      *ngIf="form.controls['assuranceType']?.value === assuranceFreeType"
    >
      <label class="form-label" for="">
        {{ "case.case-informations.free-type" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.freeType?.label"
      ></app-readonly-input>
    </div>

    <div
      class="mb-3"
    >
      <label class="form-label" for="">
        {{ "case.case-informations.assurance-corporate-type" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.institution?.label"
      ></app-readonly-input>
    </div>

    <div class="mb-3">
      <label class="form-label" for="">
        {{ "case.case-informations.price-type" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.priceType?.label"
      ></app-readonly-input>
    </div>
    <div class="mb-3" *ngIf="!hiddenFields['causeReason']">
      <label class="form-label" for="">
        {{ "case.case-informations.cause-reason" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.causeReason?.label"
      ></app-readonly-input>
    </div>

    <div class="mb-3" *ngIf="!hiddenFields['serviceReason']">
      <label for="hastaNo" class="form-label"
        >{{ "case.case-informations.service-reason" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.serviceReason?.label"
      ></app-readonly-input>
    </div>

    <div class="mb-3 row" *ngIf="!hiddenFields['protocolNo']">
      <div class="col-md-6">
        <label class="form-label" for=""
          >{{ "case.case-informations.protocol-no" | translate }}
        </label>
        <app-readonly-input
          [value]="readonlyInformations?.protocolNo"
        ></app-readonly-input>
      </div>

      <div class="col-md-6" *ngIf="!hiddenFields['labmedNo']">
        <label class="form-label" for="">{{
          "case.case-informations.labmed" | translate
        }}</label>
        <app-readonly-input
          [value]="readonlyInformations?.labmedNo"
        ></app-readonly-input>
      </div>
    </div>

    <div class="mb-3" *ngIf="!hiddenFields['triage']">
      <label class="form-label" for="">
        {{ "case.case-informations.triage" | translate }}
      </label>
      <app-readonly-input
        [value]="readonlyInformations?.triage?.label"
      ></app-readonly-input>
    </div>

    <div class="mb-3">
      <label for="notlar" class="form-label">{{
        "case.case-informations.user-note" | translate
      }}</label>
      <app-readonly-input
        [value]="readonlyInformations?.userNote"
        [type]="'textarea'"
      ></app-readonly-input>
    </div>
  </div>
  <div class="col-lg-6 divider-col">
    <div
      class="mb-3"
      *ngIf="form.controls['assuranceType']?.value === assuranceIndividualType"
    >
      <app-member-input
        (selectOn)="onMemberSelect($event)"
        #memberInput
        [isReadOnly]="isCaseApproved ?? false"
      ></app-member-input>
    </div>

    <div class="mb-3">
      <label for="notlar" class="form-label">
        {{ "case.case-informations.complaint" | translate }}</label
      >
      <app-readonly-input
        [value]="readonlyInformations?.complaint"
        [type]="'textarea'"
      ></app-readonly-input>
    </div>
    <div class="col-xl-12">
      <label class="form-check-label" for="">{{
        "case.case-informations.diagnosis" | translate
      }}</label>
      
      <!-- [icdCodes]="icdCodeList" -->
      <app-medical-records
        [medicalRecords]="diagnoses"
        [isReadOnly]="true"
        (medicalRecordsChange)="updateMedicalRecords($event)"
        [showType]="'user'"
        #medicalRecord
      ></app-medical-records>
    </div>
  </div>
  }@else {
  <div class="col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="">
        {{ "case.case-informations.assurance-type" | translate }}
      </label>
      @if(!isCaseApproved){
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="assuranceTypes"
        formControlName="assuranceType"
        [filter]="true"
        appendTo="body"
        [showClear]="true"
        [placeholder]="'case.case-informations.assurance-type' | translate"
      ></p-dropdown>
      }@else{
      <app-readonly-input
        [value]="readonlyInformations?.assuranceType?.label"
      ></app-readonly-input>
      }
    </div>

    <div
      class="mb-3"
      *ngIf="form.controls['assuranceType']?.value === assuranceFreeType"
    >
      <label class="form-label" for="">
        {{ "case.case-informations.free-type" | translate }}
      </label>
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="freeTypes"
        formControlName="freeType"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        [placeholder]="'case.case-informations.free-type' | translate"
      ></p-dropdown>
    </div>

    <div
      class="mb-3"
    >
      <label class="form-label" for="">
        {{ "case.case-informations.assurance-corporate-type" | translate }}
      </label>
      @if(!isCaseApproved){
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="institutions"
        formControlName="institution"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [loading]="!institutions || institutions.length === 0"
        [showClear]="true"
        appendTo="body"
        [placeholder]="
          'case.case-informations.assurance-corporate-type' | translate
        "
      ></p-dropdown>
      }@else{
      <app-readonly-input
        [value]="readonlyInformations?.institution?.label"
      ></app-readonly-input>
      }
    </div>
    <div class="mb-3">
      <label class="form-label" for="">
        {{ "case.case-informations.price-type" | translate }}
      </label>
      @if(!isCaseApproved){
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="priceTypes"
        formControlName="priceType"
        [filter]="true"
        [showClear]="false"
        appendTo="body"
        [placeholder]="'case.case-informations.price-type' | translate"
      ></p-dropdown>
      } @else{
      <app-readonly-input
        [value]="readonlyInformations?.priceType?.label"
      ></app-readonly-input>
      }
    </div>
    <div class="mb-3" *ngIf="!hiddenFields['causeReason']">
      <label class="form-label" for="">
        {{ "case.case-informations.cause-reason" | translate }}
      </label>
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="causeReasons"
        formControlName="causeReason"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        [placeholder]="'case.case-informations.cause-reason' | translate"
      ></p-dropdown>
    </div>
    <div class="row">
      <div class="col-lg-6" *ngIf="!hiddenFields['serviceReason']">
        <div class="mb-3">
          <label for="hastaNo" class="form-label">
            {{ "case.case-informations.service-reason" | translate }}
          </label>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="serviceReasons"
            formControlName="serviceReason"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            [placeholder]="'case.case-informations.service-reason' | translate"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-lg-6" *ngIf="!hiddenFields['triage']">
        <div class="mb-3">
          <label class="form-label" for="">
            {{ "case.case-informations.triage" | translate }}
          </label>

          @if(!isCaseApproved){
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="triages"
            formControlName="triage"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            [placeholder]="'case.case-informations.triage' | translate"
          ></p-dropdown>
          } @else{
          <app-readonly-input
            [value]="readonlyInformations?.triage?.label"
          ></app-readonly-input>
          }
        </div>
      </div>
    </div>

    <div class="mb-3 row" *ngIf="!hiddenFields['protocolNo']">
      <div class="col-md-6">
        <label class="form-label" for=""
          >{{ "case.case-informations.protocol-no" | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="protocolNo"
          [placeholder]="'case.case-informations.protocol-no' | translate"
        />
      </div>

      <div class="col-md-6" *ngIf="!hiddenFields['labmedNo']">
        <label class="form-label" for="">{{
          "case.case-informations.labmed" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="labmedNo"
          [placeholder]="'case.case-informations.labmed' | translate"
        />
      </div>
    </div>
    <div class="mb-3">
      <label for="notlar" class="form-label">{{
        "case.case-informations.user-note" | translate
      }}</label>
      <textarea
        id="notlar"
        class="form-control"
        rows="3"
        [placeholder]="'case.case-informations.user-note' | translate"
        formControlName="userNote"
      ></textarea>
    </div>
  </div>
  <div class="col-lg-6 divider-col">
    <div
      class="mb-3"
      *ngIf="form.controls['assuranceType']?.value === assuranceIndividualType"
    >
      <app-member-input
        (selectOn)="onMemberSelect($event)"
        #memberInput
        [isReadOnly]="isCaseApproved ?? false"
      ></app-member-input>
    </div>
    <div class="mb-3">
      <label for="staff" class="form-label"> Sorumlu Personel </label>

    <p-dropdown [options]="staffList" optionLabel="label" optionValue="value" dataKey="value" formControlName="staff"
      [filter]="true" [showClear]="true" appendTo="body"></p-dropdown>
    <div class="row" *ngIf="isExcelData">
      <div class="col-lg-6 mb-3">
        <label class="form-label">Destek Personel</label>
        <input type="text" class="form-control" pInputText formControlName="supportStaff"
          placeholder="Destek Personel Adı Giriniz" />
      </div>

      <div class="col-lg-6 mb-3">
        <label class="form-label">Zaman</label>
        <input type="text" class="form-control" pInputText formControlName="time" placeholder="Zaman Giriniz" />
      </div>
    </div>

    <div class="row" *ngIf="isExcelData">
      <div class="col-lg-6 mb-3">
        <label class="form-label">Departman</label>
        <input type="text" class="form-control" pInputText formControlName="department"
          placeholder="Departman Adı Giriniz" />
      </div>

      <div class="col-lg-6 mb-3">
        <label class="form-label">Tedarikçi</label>
        <input type="text" class="form-control" pInputText formControlName="supplier" placeholder="Tedarikçi Adı Giriniz" />
      </div>
    </div>
    </div>
    <div class="mb-3">
      <label for="notlar" class="form-label">
        {{ "case.case-informations.complaint" | translate }}</label
      >
      <textarea
        class="form-control"
        rows="3"
        [placeholder]="'case.case-informations.complaint' | translate"
        formControlName="complaint"
      ></textarea>
    </div>
    <div class="col-xl-12">
      <label class="form-check-label" for="">{{
        "case.case-informations.diagnosis" | translate
      }}</label>
      <!-- [icdCodes]="icdCodeList" -->
      <app-medical-records
        [medicalRecords]="diagnoses"
        (medicalRecordsChange)="updateMedicalRecords($event)"
        [showType]="'user'"
        #medicalRecord
      ></app-medical-records>
    </div>
  </div>
  }
</form>
